module.exports = __webpack_public_path__ + "static/media/google_nl.f368a49c.png";